/* Response Time CSS */

export default theme => ({
    rootClassName:{
        width:"100%"
    },
    rounded:{
        width:"30px",
        height:"28px",
        backgroundColor:"#FF7E00"
    },
    header: {
        color: theme.palette.text.secondary,
        borderBottom: "none"
      },
    portletFooter:{
        borderBottom:"0px",
        backgroundColor:"red"
    },
    buttonClosed:{
        textAlign:"right",
        marginLeft: '50px',
        color:'black'
    },
    portletToolbar:{
    }
});

